import { GetPatientsBalanceResponse_PatientBalance } from '@weave/schema-gen-ts/dist/schemas/payments/messages/commands/commands.pb';

export const searchByText = (data: GetPatientsBalanceResponse_PatientBalance[], searchValue: string) => {
  if (!searchValue || !data) {
    return data ?? [];
  }

  const searchLower = searchValue.toLowerCase();
  return data.filter((patient) => {
    const fullName = `${patient.firstName} ${patient.lastName}`.toLowerCase();
    const patientId = patient.patientId ?? '';
    const phoneNumber = patient.phoneNumber ?? '';

    return fullName.includes(searchLower) || patientId.includes(searchLower) || phoneNumber.includes(searchLower);
  });
};
